import React from "react";
import "../styles/preloader.scss";

const Preloader = () => {
  return (
    <div className="preloader-container">
      <div className="preloader">
        <div className="preloader__ring">
          <div className="preloader__sector text">K</div>
          <div className="preloader__sector text">U</div>
          <div className="preloader__sector text">X</div>
          <div className="preloader__sector text">T</div>
          <div className="preloader__sector text">E</div>
          <div className="preloader__sector text">C</div>
          <div className="preloader__sector text">H</div>
          <div className="preloader__sector text"></div>
          <div className="preloader__sector text"></div>
          <div className="preloader__sector text">K</div>
          <div className="preloader__sector text">U</div>
          <div className="preloader__sector text">X</div>
          <div className="preloader__sector text">T</div>
          <div className="preloader__sector text">E</div>
          <div className="preloader__sector text">C</div>
          <div className="preloader__sector text">H</div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
        </div>
        <div className="preloader__ring">
          <div className="preloader__sector text">K</div>
          <div className="preloader__sector text">U</div>
          <div className="preloader__sector text">X</div>
          <div className="preloader__sector text">T</div>
          <div className="preloader__sector text">E</div>
          <div className="preloader__sector text">C</div>
          <div className="preloader__sector text">H</div>
          <div className="preloader__sector text"></div>
          <div className="preloader__sector text"> </div>
          <div className="preloader__sector text">K</div>
          <div className="preloader__sector text">U</div>
          <div className="preloader__sector text">X</div>
          <div className="preloader__sector text">T</div>
          <div className="preloader__sector text">E</div>
          <div className="preloader__sector text">C</div>
          <div className="preloader__sector text">H</div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
          <div className="preloader__sector"></div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
